import { monthNames } from "./getLevel-helper";

export const getDateInfo = () => {
    const currentDate = new Date();
  
    const firstDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
    const lastDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
    const prevFirstDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1);
    const prevLastDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 0);
  
    const getDate = (date) => {
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const day = date.getDate().toString().padStart(2, "0");
      return { year, month, day };
    };

    const formatDate = (date) => {
      const { year, month, day } = getDate(date);
      return `${year}-${month}-${day}`;
    };

    const formatDateTime = (date) => {
      const { year, month, day } = getDate(date);
      const hours = date.getHours().toString().padStart(2, "0");
      const minutes = date.getMinutes().toString().padStart(2, "0");
      const seconds = date.getSeconds().toString().padStart(2, "0");
      return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
    };

    const formatDateMY = (date) => {
      const { year, month, day } = getDate(date);
      return `${day}-${month}-${year}`;
    }
  
    const startDate = formatDate(firstDayOfMonth);
    const startDatePrev = formatDate(prevFirstDayOfMonth);
    const lastDatePrev = formatDate(prevLastDayOfMonth);
    const lastDate = formatDate(lastDayOfMonth);
    const todaysDate = formatDate(currentDate);
    const lastRefreshed = formatDateTime(currentDate);
    const todaysDateMY = formatDateMY(currentDate);
  
    return {
      startDate,
      startDatePrev,
      lastDatePrev,
      lastDate,
      todaysDate,
      lastRefreshed,
      todaysDateMY
    };
  };
  
export class DateByCountryHelper {
  constructor(selectedCountryCode, userDetails, startDate, startDatePrev, lastDate, lastDatePrev) {
    this.selectedCountryCode = selectedCountryCode;
    this.userDetails = userDetails;
    this.startDate = startDate;
    this.startDatePrev = startDatePrev;
    this.lastDate = lastDate;
    this.lastDatePrev = lastDatePrev;
  }

  getStartDates() {
    if (this.selectedCountryCode === "pk") {
      return [
        this.userDetails?.currentMonth?.monthStartDate,
        this.userDetails?.previousMonth?.monthStartDate,
      ];
    }
    return [this.startDate, this.startDatePrev];
  }

  getEndDates() {
    if (this.selectedCountryCode === "pk") {
      return [
        this.userDetails?.currentMonth?.monthEndDate,
        this.userDetails?.previousMonth?.monthEndDate,
      ];
    }
    return [this.lastDate, this.lastDatePrev];
  }
}

export const getMonthOptions = (selectedCountryCode, userDetails, isPerfectStoreTab = false) => {
  const currentDate = new Date();
  const currentMonth = currentDate.getMonth();
  const currentYear = currentDate.getFullYear();
  const monthOptions = [];

  const getPreviousMonth = (month, year) => {
    if (month === 0) {
      return { previousMonth: 11, previousYear: year - 1 }; // Transition from January to December of the previous year
    }
    return { previousMonth: month - 1, previousYear: year };
  };

  const isDayOptionExcluded =
    isPerfectStoreTab && (selectedCountryCode === "pk" || selectedCountryCode === "th");

  if (!isDayOptionExcluded) {
    const dayLabel = "Today";
    monthOptions.push({ value: "day", label: dayLabel });
  }

  if (selectedCountryCode === "pk") {
    monthOptions.push({
      value: "mtd",
      label: `JC-${userDetails?.currentMonth?.monthNumber}`,
    });
    monthOptions.push({
      value: "PreviousMonth",
      label: `JC-${userDetails?.previousMonth?.monthNumber}`,
    });
  } else {
    monthOptions.push({
      value: "mtd",
      label: `${monthNames[currentMonth]} ${currentYear}`,
    });
    const { previousMonth, previousYear } = getPreviousMonth(currentMonth, currentYear);
    monthOptions.push({
      value: "PreviousMonth",
      label: `${monthNames[previousMonth]} ${previousYear}`,
    });
  }

  return monthOptions;
};

export const isExcludedDateField = (field) => {
  const excludedFields = [
    "totalVisitTime",
    "taxNumberUpdateTs",
    "einvoiceEmailUpdateTs",
  ];

  return excludedFields.includes(field);
};

export const parseDDMMYYYY = (dateStr) => {
  if (!dateStr) return null;

  const parts = dateStr.split("-");
  if (parts.length !== 3) return null;

  const [day, month, year] = parts;
  return new Date(year, month - 1, day);
};
